export class  Status {
  idStatus:string;
  Status:string;
}
